import {Component, Input} from "@angular/core";
import { PageButton, PageButtonType, PageWidth} from "../../../_types/PageContainerTypes";
import {MenuService} from "../../services/menu.service";

@Component({
    selector: "app-page-container",
    templateUrl: "./page-container.component.html",
    styleUrls: ["./page-container.component.scss"]
})
export class PageContainerComponent {

    constructor(public menuService: MenuService) {
    }

    @Input()
    public title: string;

    @Input()
    public buttons: PageButton[];

    @Input()
    public width: PageWidth;

    @Input()
    public leftButtons: PageButton[] = [];

    public buttonClasses = {
        [PageButtonType.CONFIRM]: "btn-success",
        [PageButtonType.DANGER]: "btn-danger",
        [PageButtonType.NEUTRAL]: "btn-secondary",
        [PageButtonType.PRIMARY]: "btn-primary",
        [PageButtonType.OUTLINE_PRIMARY]: "btn-outline-primary",
        [PageButtonType.DARK]: "btn-dark",
        [PageButtonType.INFO]: "btn-info",
        [PageButtonType.WARNING]: "btn-warning",

    };


    public widthClasses = {
        [PageWidth.PP]: "col-4 offset-4",
        [PageWidth.P]: "col-6 offset-3",
        [PageWidth.M]: "col-8 offset-2",
        [PageWidth.G]: "col-10 offset-1",
        [PageWidth.GG]: "col-12",
    };

    public isBtnDisabled(btn) {
        return typeof btn.disabled === "function" ? btn.disabled() : btn.disabled;
    }

}
